// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetTranslateTerminologyConfigsByIdParam,
    BaseResponseTranslateTerminologyConfigFoundResponse,
    PutTranslateTerminologyConfigsByIdParam,
    PutTranslateTerminologyConfigsByIdBody,
    BaseResponseVoid,
    DeleteTranslateTerminologyConfigsByIdParam,
} from '../../types';

/**
 * 详情
 *
 * @export
 * @tags translate-terminology-config-controller
 * @link [GET] /translateTerminologyConfigs/{id}
 * @param id
 */
export function getTranslateTerminologyConfigsById(
    options: ApiOptions<GetTranslateTerminologyConfigsByIdParam, never> & {
        segments: GetTranslateTerminologyConfigsByIdParam;
    }
): Promise<BaseResponseTranslateTerminologyConfigFoundResponse> {
    return request<never, GetTranslateTerminologyConfigsByIdParam, never>(
        '/translateTerminologyConfigs/{id}',
        { ...options, method: 'get', __$requestCalleeName: 'getTranslateTerminologyConfigsById' }
    );
}

/**
 * 更新
 *
 * @export
 * @tags translate-terminology-config-controller
 * @link [PUT] /translateTerminologyConfigs/{id}
 * @param id
 */
export function putTranslateTerminologyConfigsById(
    data: PutTranslateTerminologyConfigsByIdBody,
    options: ApiOptions<PutTranslateTerminologyConfigsByIdParam, never> & {
        segments: PutTranslateTerminologyConfigsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<
        PutTranslateTerminologyConfigsByIdBody,
        PutTranslateTerminologyConfigsByIdParam,
        never
    >('/translateTerminologyConfigs/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putTranslateTerminologyConfigsById',
    });
}

/**
 * 删除
 *
 * @export
 * @tags translate-terminology-config-controller
 * @link [DELETE] /translateTerminologyConfigs/{id}
 * @param id
 */
export function deleteTranslateTerminologyConfigsById(
    options: ApiOptions<DeleteTranslateTerminologyConfigsByIdParam, never> & {
        segments: DeleteTranslateTerminologyConfigsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteTranslateTerminologyConfigsByIdParam, never>(
        '/translateTerminologyConfigs/{id}',
        {
            ...options,
            method: 'delete',
            __$requestCalleeName: 'deleteTranslateTerminologyConfigsById',
        }
    );
}

export const meta = [
    {
        tags: ['translate-terminology-config-controller'],
        path: '/translateTerminologyConfigs/{id}',
        method: 'get',
    },
    {
        tags: ['translate-terminology-config-controller'],
        path: '/translateTerminologyConfigs/{id}',
        method: 'put',
    },
    {
        tags: ['translate-terminology-config-controller'],
        path: '/translateTerminologyConfigs/{id}',
        method: 'delete',
    },
];
